module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABRSURBVHgB3VFbCgAgCLPorh6jdQxP2wMiKAizjz7al6iTzTlaICKRFHiyA2RFVZJDl4ODfTBzakVYG5vrk88bTz+SYCa1L7/zNMKtAULZHfMCGs0UtRFRhxMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/copy.png
// module id = 464
// module chunks = 7